export function parsePhoneNumbers(phoneNumbers: string) {
	if (!phoneNumbers) {
		return [];
	}
	const splittedPhoneNumbers = phoneNumbers.split('/');
	return splittedPhoneNumbers.filter(item => item);
}
